import React from 'react';
import { translate } from 'react-i18next';
import { node, func, string } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { ChevronRightIcon } from '@snapask/common-components';

import { getZendeskFAQLink } from '@dragonfruit/redux/siteInfo';
import { actions } from '@dragonfruit/redux/report';

import styles from './Contact.scss';

import faqIcon from './images/icon_faq.svg';
import emailIcon from './images/icon_email.svg';
import phoneIcon from './images/icon_phone.svg';

const mapStateToProps = state => ({
  zendeskFAQLink: getZendeskFAQLink(state),
});
function HelpItem({ icon, title, children }) {
  return (
    <div className={styles.helpItem}>
      <div className={styles.icon}>
        <img src={icon} />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        {children}
      </div>
    </div>
  );
}

HelpItem.propTypes = {
  children: node.isRequired,
  icon: string.isRequired,
  title: string.isRequired,
};

const Contact = ({ t, toggleReportForm, zendeskFAQLink }) => {
  const showContactInfo = t('contact.contact.title') !== '-';

  return (
    <div className={styles.root}>
      <div
        className={styles.left}
        style={{ backgroundImage: `url(${t('contact.helpBackgroundImg')})` }}
      >
        <img className={styles.helpUser} src={t('contact.helpUserImg')} />
      </div>
      <div className={styles.right}>
        <h4 className={styles.heading}>{t('contact.contactInfoTitle')}</h4>
        <div className={styles.helpInfo}>
          <HelpItem icon={faqIcon} title={t('contact.help.title')}>
            <a
              className={styles.link}
              href={zendeskFAQLink}
              target="_blank"
              rel="noreferrer"
            >
              {t('contact.help.linkText')}
              <ChevronRightIcon
                className={styles.arrowIcon}
                width={24}
                height={24}
              />
            </a>
          </HelpItem>
          <HelpItem icon={emailIcon} title={t('contact.report.title')}>
            <p>{t('contact.report.description')}</p>
            <a className={styles.link} onClick={toggleReportForm}>
              {t('contact.report.linkText')}
            </a>
          </HelpItem>
          {showContactInfo && (
            <HelpItem icon={phoneIcon} title={t('contact.contact.title')}>
              <p>{t('contact.contact.phone')}</p>
              <p>{t('contact.contact.openHours')}</p>
            </HelpItem>
          )}
        </div>
      </div>
    </div>
  );
};

Contact.propTypes = {
  t: func.isRequired,
  toggleReportForm: func.isRequired,
  zendeskFAQLink: string.isRequired,
};

export default compose(
  translate(['contact', 'common']),
  connect(mapStateToProps, {
    toggleReportForm: actions.toggleReportForm,
  })
)(Contact);



// WEBPACK FOOTER //
// ./app/containers/Tutors/components/Contact/Contact.jsx